import React from "react";
import Header from "../Components/Header";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from '../api';
import Footer from "../Components/Footer";
import SimpleKakaoButton from "../Components/SimpleKakaoButton";

const SecretFreeTrial = () => {
  const navigate = useNavigate();

  const freePlan = {
    name: "무료 체험",
    description: "비밀 링크를 통해 접근 가능한 특별 혜택",
    type: "free",
    features: [
      "URL A/B 테스트",
      "비주얼 A/B 테스트",
      "프로젝트 최대 1개",
      "6개월 데이터 보관"
    ]
  };

  const handleTrialSignup = async () => {
    try {
      const response = await api.post('payments/trial/');
      const WorkspaceCode = response.data.workspace;
      
      if (WorkspaceCode) {
        window.location.href = `${process.env.REACT_APP_APP_DOMAIN}/projects/${WorkspaceCode}/overview`
      } else {
        window.location.href = `${process.env.REACT_APP_APP_DOMAIN}/workspaces`
      }

    } catch (error) {
      if (error.response?.data?.message) {
        alert(error.response.data.message);
      }
      console.error('Trial signup failed:', error);
    }
  };

  return (
    <div className="bg-white">
      <Header />
      
      <div className="min-h-screen bg-gray-50 pt-24 px-4">
        <div className="max-w-3xl mx-auto">
          {/* 비밀 링크 배너 */}
          <div className="text-center mb-16">
            <div className="inline-block bg-purple-600 text-white text-sm font-semibold px-3 py-1 rounded-full mb-3">
              비밀 초대장
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              특별 무료 체험 접근 페이지
            </h1>
            <p className="text-xl text-gray-600">
              이 페이지는 비밀 링크를 통해서만 접근할 수 있습니다
            </p>
          </div>

          {/* 무료 체험 카드 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-16 max-w-md mx-auto">
            {/* 카드 헤더 */}
            <div className="p-6 border-b border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900">{freePlan.name}</h3>
              <p className="text-gray-500 mt-2">{freePlan.description}</p>
              <div className="mt-4">
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-gray-900">₩0</div>
                  <div className="inline-block bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full">
                    특별 무료 체험
                  </div>
                </div>
              </div>
            </div>

            {/* 카드 컨텐츠 */}
            <div className="p-6">
              {/* 플랜 기능 목록 */}
              <ul className="space-y-4 mb-6">
                {freePlan.features.map((feature) => (
                  <li key={feature} className="flex items-center">
                    <Check className="h-5 w-5 text-blue-600 mr-2" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* 액션 버튼 */}
              <button 
                className="w-full px-8 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
                onClick={handleTrialSignup}
              >
                무료로 시작하기
              </button>
            </div>
          </div>

          {/* 비밀 링크 안내 */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-16 max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">특별 무료 체험 안내</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <Check className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-600">이 특별 혜택은 비밀 링크를 통해 접근한 분들께만 제공됩니다.</span>
              </div>
              <div className="flex items-start">
                <Check className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-600">무료 체험 기간 동안 모든 기능을 제한 없이 사용해보세요.</span>
              </div>
              <div className="flex items-start">
                <Check className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-600">
                  무료 체험 종료 후에는 자동으로 요금이 부과되지 않습니다.
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <SimpleKakaoButton 
          channelId="_yixgxjn"
          buttonText="문의하기" 
        /> */}
        <Footer/>
      </div>
    </div>
  );
};

export default SecretFreeTrial;